// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"8527d0ac","455":"b021b6d9","977":"95fab7d0"}[chunkId] + ".chunk.js";
};